<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
import {Chat} from './assets/js/chatLive';
export default {
  name: "App",
  updated() {
    this.$store.commit('header/setMobile', this.checkMobile());
  },
  mounted() {
    const self = this;
    this.$store.commit('header/setMobile', this.checkMobile());
    // this.$autoLogin().then(
    //     () => {
    //         window.sessionStorage.setItem("course_login_flg", 1);
    //     },
    //     () => {
    //         window.sessionStorage.setItem("course_login_flg", 0);
    //         let token = window.document.cookie.match('(^|;) ?token=([^;]*)(;|$)');
    //         token = token ? token[2] : null;
    //         let courseLoginFlg = window.sessionStorage.getItem("course_login_flg");
    //         if (token&&courseLoginFlg=="0") {
    //             let _date = new Date();
    //             _date.setDate(_date.getDate() - 1);
    //             _date.toGMTString();
    //             document.cookie = "token='';expires=" + _date.toGMTString();
    //             document.cookie = "remember='';expires=" + _date.toGMTString();
    //             window.location.reload();
    //         }
    //     }
    // );
    if (this.checkGeneralEnvironmentDongDu() == true && !this.checkMobile()) {
      // Khỏi tạo chat box
      var chat = new Chat();
      chat.load();

      // Chạy mỗi khi nhận tin nhắn
      window.addEventListener("message", chat.receiveMessageLiveChat);
    }
    function doOnOrientationChange() {
      self.$store.commit('header/setMobile', self.checkMobile());
    }
    
    window.addEventListener('orientationchange', doOnOrientationChange);
  },
};
</script>

<style>
@import "./common/font/font.css";
@import "../static/css/wix/languages.css";
@import "../static/css/wix/languages2.css";
@import "../static/css/style-custom.css";
@import "../static/css/reponsive.css";
@import "../static/css/font-css/css/roboto.css";

ul,
ol {
  list-style: none;
}

input {
  outline: none;
}

img {
  display: block;
  border: 0;
}

header,
footer,
nav,
main,
article,
aside,
section {
  display: block;
}

a {
  text-decoration: none;
}

html,
body {
  font-size: 12px;
}

body,
h1,
h2,
h3,
h4,
h5,
h6,
ol,
ul,
li,
dl,
dt,
p,
dd,
input,
img,
a,
div,
span,
figure,
figcaption {
  padding: 0;
  margin: 0;
}

button {
  outline: none;
  cursor: pointer;
}

.cursor {
  cursor: pointer;
}

/*适配Safari浏览器 input输入框中光标高度的问题*/
input {
  line-height: normal !important;
}

input:focus,
textarea:focus {
  border: 1px #02ADFF solid !important;
}

/* 设置滚动条的样式 */
.main_page ::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 6px;
  /*height: 100%;*/
  border-radius: 20px;
}

.main_page ::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 20px;
  background-color: #bbbbbb;
}

.main_page ::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 20px;
  /* background-color: #999997; */
  background-color: #f9f9f9;
  /* margin-right: 10px; */
}

/* 设置滚动条的样式 */
.curriculumPage_main_page ::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 6px !important;
  border-radius: 20px;
}

.curriculumPage_main_page ::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 20px;
  background-color: #bbbbbb;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
}

.curriculumPage_main_page ::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 20px;
  /* background-color: #999997; */
  background-color: #f9f9f9;
}

::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  font-size: 13px;
  color: rgb(232, 230, 230);
  font-weight: 200;
  font-style: normal;
}

:-moz-placeholder {

  font-size: 13px;
  color: rgb(232, 230, 230);
  font-weight: 200;
  font-style: normal;
}

::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  font-size: 13px;
  color: rgb(232, 230, 230);
  font-weight: 200;
  font-style: normal;
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  font-size: 13px;
  color: rgb(232, 230, 230);
  font-weight: 200;
  font-style: normal;
}

pre {
  white-space: pre-wrap;
  /* css-3 */
  white-space: -moz-pre-wrap;
  /* Mozilla, since 1999 */
  white-space: -pre-wrap;
  /* Opera 4-6 */
  white-space: -o-pre-wrap;
  /* Opera 7 */
  word-wrap: break-word;
  /* Internet Explorer 5.5+ */
  margin: 0;
}

.main_page {
  min-width: 580px;
  margin: 0 auto;
  min-height: 60px;
}

.index_page {
  min-width: 580px;
  margin: 0 auto;
}

.swipe_shandow {
  /* border-bottom-left-radius: 20px;
		border-bottom-right-radius: 20px; */
  border-radius: 20px;
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.5);
}

.index_page .el-carousel__indicators--outside {
  margin-top: 490px;
}
.index_page .el-carousel__indicator {
  position: relative;
  z-index: 2;
}

.hr_red {
  width: 70px;
  height: 4px;
  background-color: #e91926 !important;
  border: 0;
  display: flex;
}

.index-div2 .index-div2-li .el-carousel__container {
  overflow: hidden;
  display: table-footer-group;
  height: auto !important;
}

.index-div2 .index-div2-li .el-carousel__arrow {
  height: 130px;
  width: 34px;
  font-size: 42px;
  background-color: unset;
}

.index-div2 .index-div2-li .el-carousel__arrow:hover {
  background-color: unset;
}

.index-div2 .index-div2-li .el-carousel {
  height: 520px;
  /* display: list-item; */
  /* display: block; */
}

.index-div2 .index-div2-li:nth-child(2) .el-carousel__arrow {
  color: #323232;
}

.distance_top_20 {
  margin-top: 20px;
}

.distance_top_30 {
  margin-top: 15px !important;
}

.distance_top_40 {
  margin-top: 40px;
}

.distance_top_50 {
  margin-top: 50px;
}

.el-dialog {
  box-shadow: unset !important;
  width:60%;
}

.home_dialog_page .el-dialog__body {
  background-color:rgba(0,0,0,0);
  padding: 0;
  margin-left: -20px;
}

.home_dialog_page .el-dialog__header {
  padding-top: 0;
}

.home_dialog_page .el-dialog {
  width: 500px !important;
  margin-top: 80px !important;
  background-color: rgba(0,0,0,0);
  margin: 0 auto;
}

.home_dialog_page.report .el-dialog {
  width: 650px !important;
  margin-top: 30px !important;
}
.home_dialog_page.report .el-dialog__headerbtn{
  top:50px;
  right:17px;
  z-index:2;
}
.home_dialog_page.report .el-dialog__headerbtn .el-dialog__close{
color:#fff;
transition:0.5s ease;
}
.home_dialog_page.report .el-dialog__headerbtn .el-dialog__close:hover{
color:#CECECE;
transition:0.5s ease;
cursor: pointer;
}

.home_dialog_page .el-dialog .el-pager li {
  background: unset !important;
}

.home_dialog_page .el-form-item {
  margin-bottom: 10px !important;
}

.home_dialog_page .el-form-item__content {
  margin-left: 0 !important;
}

.home_dialog_page .el-input {
  width: 238px !important;
  height: 32px !important;
  margin-left: 30px !important;
}

.home_dialog_page .el-input .el-input__inner {
  height: 30px !important;
  /* line-height: 30px !important; */
  line-height: normal !important;
  /*适配Safari浏览器 input输入框中光标高度的问题*/
  vertical-align: middle;
  border-radius: 20px !important;
  font-size: 13px;
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.8);
}

.home_dialog_page .el-input ::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  font-size: 12px;
}

.home_dialog_page .el-input :-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  font-size: 12px;
}

.home_dialog_page .el-input ::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  font-size: 12px;
}

.home_dialog_page .el-input :-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  font-size: 12px;
}

.home_dialog_page .el-checkbox-group {
  width: 220px !important;
  height: 10px !important;
  line-height: 10px;
  margin-left: 42px !important;
}

.home_dialog_page.report .el-radio-group {
  width: 100% !important;
  height: 15px !important;
  margin: 0 auto !important;
  text-align: center;
  font-weight: 200;
  font-style: normal;
}

.home_dialog_page.report .el-radio-group .el-radio {
  margin-right: 110px;
}

.home_dialog_page.report .el-radio-group .el-radio:last-child {
  margin-right: 0;
}

.home_dialog_page.report
  .el-radio-group
  .el-radio__input.is-checked
  .el-radio__inner {
  border-color: #fff !important;
  background: #fff !important;
}

.home_dialog_page.report .el-radio-group .el-radio__inner:hover {
  border-color: #6a6a6a !important;
}

.home_dialog_page.report
  .el-radio-group
  .el-radio__input.is-checked
  .el-radio__inner::after {
  width: 6px !important;
  height: 6px !important;
  left: 6px !important;
  background: #6a6a6a !important;
}

.home_dialog_page.report .el-textarea {
  display: inline-block;
  width: 84%;
  vertical-align: bottom;
  font-size: 14px;
  margin: 0 auto;
  text-align: center;
  margin-left: 8%;
  border-radius: 20px;
  background-color: rebeccapurple;
}

.home_dialog_page.report .el-textarea__inner {
  display: block;
  resize: vertical;
  padding: 5px 15px;
  line-height: 20px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  font-size: 14px;
  color: #ffffff;
  background-color: #393939;
  box-shadow: 1px 2px 0px 0px rgba(33, 23, 20, 0.14);
  background-image: none;
  border-radius: 20px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  border: 1px #393939 solid;
  height: 156px;
  overflow: hidden;
  text-overflow: ellipsis;
  resize: none;
  font-weight: 200;
  font-style: normal;
}

.home_dialog_page.report .el-radio__input.is-checked + .el-radio__label {
  color: inherit;
}

.home_dialog_page.report .el-row {
  text-align: center;
}

.home_dialog_page .el-checkbox {
  height: 30px !important;
}

.el-checkbox__inner {
  border-radius: 50% !important;
  /* width:10px !important;
        height: 10px !important; */
}

.home_dialog_page .el-checkbox__label {
  font-size: 11px !important;
  color: rgb(232, 230, 230);

  font-weight: 200;
  font-style: normal;
  margin-left: -5px;
}

.el-checkbox__label {
  color: #e8e6e6 !important;
}

.buyPro_main .buyPro_right .pay_content .pay_mode .el-radio {
  height: 100px;
}

.buyPro_main .buyPro_right .pay_content .pay_mode .el-radio__input {
  display: block;
  margin-top: 80px;
}

.buyPro_main .buyPro_right .el-checkbox__label {
  color: #e8e6e6 !important;
  font-size: 11px;
}

.task_el_pagination {
  text-align: center;
}

.taskContent_page .task_el_pagination ul li {
  height: 30px;
  line-height: 30px !important;
  margin: 0 auto;
  font-size: 20px !important;
  color: #0000ff !important;
  background-color: rgba(200,200,200,0.5) !important;
  transition: 0.5s ease;
}

.taskContent_page .task_el_pagination ul li.active {
  color: #fff !important;
}

.taskContent_page .el-pagination {
  text-align: center;
}

.taskContent_page .el-pager li:hover {
  height: 30px !important;
  line-height: 30px !important;
  color: #ff5252 !important;
  font-size: 20px !important;
  transition: 0.5s ease;
}

.page_pdf .el-pagination ul li {
  color: #fff !important;
}

.resPassword .el-input .el-input__inner {
  height: 30px !important;
  vertical-align: middle;
  border-radius: 20px !important;
  margin-top: 20px;
  font-size: 13px;
  line-height: 13px !important;
  padding:8.5px 15px 8.5px 15px;
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.8);
}

html,
body,
#app {
  height: 100%;
}

body {
  overflow: hidden;
}

#app {
  overflow-y: auto;
}

#study .el-pagination button:disabled {
  background-color: transparent;
}

#study .el-pagination .btn-next,
#study .el-pagination .btn-prev {
  background-color: transparent;
}

#study .el-pagination .btn-next .el-icon,
#study .el-pagination .btn-prev .el-icon {
  color: #ffffff;
}

#study .page .el-pagination ul li {
  color: #949494;
  font-weight: 400;
  background-color: unset !important;
}

#study .page .el-pagination ul .active {
  /* color: #409EFF; */
  color: #fff;
}

.MyPost_content .el-pagination button:disabled {
  background-color: unset !important;
}

.font-15 {
  font-size: 15px !important;
}
.el-pager li{
  min-width:unset;
  color: #333;
}
.el-pagination ul li {
  height: 28px;
  width: 28px;
  line-height: 28px;
  font-size: 14px;
  font-style: normal !important;
  transition:0.5s ease;
  background: #eee;
  border-radius: 50%;
}

.el-pagination ul li:hover {
  transition:0.5s ease;
}

#aicourse .el-dialog {
  position: relative;
  margin: 0 auto 50px;
  border-radius: 15px;
  box-sizing: border-box;
  width: 50%;
  max-width: 800px;
}

#aicourse .el-dialog,
#aicourse .el-pager li {
  background: rgba(45, 47, 58, 1);
  -webkit-box-sizing: border-box;
}

#aicourse .el-dialog .el-dialog__header {
  padding: 0;
}

#aicourse .el-dialog .el-dialog__body {
  padding: 0;
  display: grid;
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.45);
  border-radius: 15px;
}

#aicourse .el-dialog video {
  outline: none;
  border-radius: 10px;
}

#aicourse .el-dialog__headerbtn {
  z-index: 99;
}

.community_comment_page .el-pager li {
  background-color: #ffffff;
  border-radius: 10px;
  border: solid 1px #e6e6e6;
  margin-right: 4px;
  color: #e6e6e6;
}

.community_comment_page .el-pager li:last-child {
  margin-right: 0px;
}

.community_comment_page .el-pager .active {
  color: #fff;
  background-color: #ff7042 !important;
}

.community_comment_page .el-pagination .btn-next,
.community_comment_page .el-pagination .btn-prev,
.el-pagination button:disabled {
  margin-right: 0;
  color: #c0c4cc !important;
  background-color: #fff;
  cursor: not-allowed;
}

.community_comment_page .el-pagination__total,
.community_comment_page .el-pagination__jump {
  font-weight: 200;
  font-style: normal;
}

.community_comment_page2 .el-pager .active {
  color: #fff;
  background-color: #30d5c8 !important;
  border:1px solid #30d5c8 !important;
}

.community_comment_page .el-pagination__editor .el-input__inner {
  border-radius: 10px !important;
}

.community_number {
  font-size:13px;
  font-weight: 300 !important;
  font-style: normal !important;
}

.community_comment_content .community_comment_page .el-pager li {
  background-color: unset;
  border-radius: unset;
  border: unset;
  margin-right: unset;
  color: #414141;
  background-color: #ffefea;
}

.community_comment_content .community_comment_page .el-pager .active {
  color: #ff7042;
  background-color: unset !important;
  border:1px #ff7042 solid !important;
}

.community_comment_content .community_comment2_page .el-pager .active {
  color: #30d5c8 !important;
  background-color: unset !important;
}
.community_comment_content .community_comment2_page .el-pager li.active + li {
  border-left: 1px #e6e6e6 solid !important;
}
.community_comment_content .community_comment_page .el-pagination .btn-next,
.community_comment_content .community_comment_page .el-pagination .btn-prev {
  background-color: #ffefea;
}

.community_comment_content
  .community_comment_page
  .el-pagination
  button:disabled {
  background-color: #ffefea;
}

#task_answer .answer .ql-container.ql-snow {
  height: 200px;
  padding:10px  4px 10px 0;
}

.testPage .answer .ql-container.ql-snow {
  height: 200px;
  padding:10px  4px 10px 0;
}

.transactionInfo_page .el-pager li {
  border-radius: 10px;
  margin-right: 4px;
  color: #949494;
  font-weight: 400;
  background-color: unset !important;
}

.transactionInfo_page .el-pager .active {
  color: #fff !important;
}

.transactionInfo_page .el-pager .el-icon-arrow-right {
  background-color: unset !important;
  color: #949494 !important;
}

.transactionInfo_page .el-pagination .btn-next,
.transactionInfo_page .el-pagination .btn-prev {
  background-color: unset !important;
}

.transactionInfo_page .el-pagination .btn-next .el-icon,
.transactionInfo_page .el-pagination .btn-prev .el-icon {
  color: #e6e6e6 !important;
}

.transactionInfo_page .el-pagination button:disabled {
  background-color: unset !important;
}

.dialog_page_main.post input:focus {
  border: 0 !important;
}

.dialog_page_main.post .dialog_page_content .text {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  padding: 2px !important;
}

.dialog_page_main.post .dialog_page_content .text textarea {
  /* border: none; */
  /* padding-left: 0; */
  color: #000000;
  resize: none;
  outline: none !important;
  font-weight: 200;
  font-style: normal;
  font-size: 14px;
  line-height: 20px !important;
  border: 0 !important;
  border-radius: 0 !important;
  transition: unset !important;
  padding: 3px 13px !important;
}

.dialog_page_main.post .dialog_page_content .text:focus {
  border: 1px solid #dcdfe6 !important;
}

.home_dialog_page.post .el-dialog__headerbtn {
  right: -19px;
}

.home_dialog_page.report .dialog_page_item > img:hover {
  color: #e0e0e0 !important;
  cursor: pointer;
}

.community_dialog_bigImages .el-dialog {
  max-width: 800px;
  min-width: 200px;
  width: 40%;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 10px;
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.5) !important;
}

.community_dialog_bigImages .el-dialog__header {
  padding: 0;
}

.community_dialog_bigImages .el-dialog .el-dialog__body {
  padding: 0;
  margin: 0;
}

.community_dialog_bigImages .el-dialog img {
  max-width: 800px;
  min-width: 200px;
  margin: 0 auto;
  padding: 0;
  border-radius: 10px;
  /* box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.5) !important; */
}

.ql-editor.ql-blank::before {
  color: #e8e6e6 !important;
}

.ql-snow .ql-stroke {
  stroke: #e8e6e6 !important;
}

/*.searchPage*/
.searchPage .el-input-group {
  width: 50%;
  margin: 0 auto;
  border: none;
}

.searchPage-home .el-input-group{
  width:100%;
}

.searchPage .el-input-group > .el-input__inner {
  background-color: #6d6d6d;
  height: 35px;
  line-height: 35px;
}

.searchPage .el-input-group > .el-input__inner:hover {
  border-color: #6d6d6d;
}

.searchPage .el-input__inner {
  border-radius: 20px 0 0 20px;
  border: 1px solid #6d6d6d;
  color: #ffffff;
  outline: none;
}

.searchPage .el-input-group__append,
.searchPage .el-input-group__prepend {
  /*background-color: #ff5555;*/
  background-image: -webkit-linear-gradient(315deg, #02ADFF 0%, #00D3FF 100%);
  background-image: linear-gradient(135deg, #02ADFF 0%, #00D3FF 100%);
  color: #ffffff;
  vertical-align: middle;
  /*border: 1px solid #ff5555;*/
  border: 1px solid #02ADFF;
  border-radius: 0 20px 20px 0;
  /* padding: 0 20px; */
  width: 50px;
  text-align: center;
}

.searchPage .el-input-group__append button.el-button {
  letter-spacing: 2px;
  font-size: 14px;
  font-weight: 200 !important;
  font-style: normal;
}

.searchPage .el-input-group__append button.el-button:hover {
  font-size: 15px;
}

.agreement_dialog_page .el-dialog {
  width: 704px;
  height: 358px;
  background-color: #323232 !important;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.35);
  border-radius: 20px;
}

.agreement_dialog_page .el-dialog .el-dialog__title {
  font-size: 22px;
  line-height: 40px;
  letter-spacing: 0px;
  color: #ffffff;
  display: block;
  text-align: center;
}

.agreement_dialog_page .el-dialog__body {
  padding: 0 !important;
}

.agreement_dialog_page .el-dialog__headerbtn .el-dialog__close {
  color: #ffffff;
  transition: 0.5s ease;
}
.agreement_dialog_page .el-dialog__headerbtn .el-dialog__close:hover {
  color: #409eff !important;
  transition: 0.5s ease;
}

.agreement_content {
  width: 629px;
  /* height: 181px; */
  background-color: #ffffff;
  border-radius: 10px;
  margin: 10px auto;
  padding: 10px;
  font-size: 14px;
  color: #000;
}

.agreement_content_main {
  overflow-y: scroll;
  width: 629px;
  height: 181px;
}

.agreement_btn {
  margin: 22px auto;
  line-height: 12px;
  padding: 8px 15px 9px 15px;
  border-radius: 14px;
  border: solid 1px #ffffff;
  font-weight: 200;
  font-style: normal;
  background-color: #323232;
  font-size: 12px;
  letter-spacing: 0px;
  color: #ffffff;
  display: block;
  cursor: pointer;
  transition: 0.5s ease;
}

.agreement_btn:hover {
  color: #323232;
  background-color: #ffffff;
  transition: 0.5s ease;
}

/* .ql-toolbar.ql-snow,.ql-container.ql-snow{
		border: 1px solid #FF5252 !important;
	} */
.el-dialog__headerbtn {
  transition: 0.5s ease;
}

.el-dialog__headerbtn,
.el-dialog__headerbtn:hover {
  transition: 0.5s ease;
}

.home_dialog_page.post.post1 .el-dialog__headerbtn .el-dialog__close{
  color:#909399;
  transition:0.5s ease;
}

.home_dialog_page.post.post1 .el-dialog__headerbtn .el-dialog__close:hover {
  color: #ff7042 !important;
  transition:0.5s ease;
}

.home_dialog_page.post.post2 .el-dialog__headerbtn .el-dialog__close:hover {
  color: #30d5c8 !important;
  transition:0.5s ease;
}

.el-pagination .btn-next,
.el-pagination .btn-prev,
.el-pagination button:disabled {
  color: #c0c4cc !important;
}

/*询问框样式修改*/
.el-message-box {
  background-color: #424242 !important;
  border: 1px solid #424242 !important;
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.3) !important;
  border-radius: 10px;
}

.el-message-box__title,
.el-message-box__message p,
.el-message-box .el-message-box__btns .el-button {
  color: #fff !important;
}

.el-message-box__headerbtn .el-message-box__close {
  color: #909399;
  transition: 0.5s ease;
}

.el-message-box__headerbtn .el-message-box__close:hover {
  color: #fff;
  transition: 0.5s ease;
}

.el-message-box .el-icon-warning:before {
  color: #fff;
  background-color: #ff5555 !important;
  border-radius: 50%;
  padding: 2px;
}

.el-message-box .el-message-box__btns .el-button {
  background-color: #424242 !important;
  border: 1px #fff solid;
  border-radius: 15px;
  padding: 4px 10px 5px 10px;
  font-size: 14px;
  transition: 0.5s ease;
}

.el-message-box .el-message-box__btns .el-button:hover {
  color: #424242 !important;
  background-color: #fff !important;
  border: 1px #424242 solid;
  transition: 0.5s ease;
}

.buyPro_main .buyPro_right .el-radio__inner::after {
  width: 6px !important;
  height: 6px !important;
}

.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
  box-shadow: unset !important;
}
.el-pager li.active + li {
  border-left: 1px #e6e6e6 solid !important;
}

.taskContent_page .el-pager li.active + li,.person_main .el-pager li.active + li{
  border-left:0 !important;
}

.comment_box .comment_box_main_right .create_comment .create_comment_textarea:focus{
  border:1px #FF7042 solid !important;
}
.comment_box .comment_box_main_right .create_comment2 .create_comment_textarea:focus{
  border:1px #66CCCC solid !important;
}
.el_dialog_live_lesson .el-dialog__header {
  background-image: -webkit-linear-gradient(0deg, #e8e6e6 0%, #fff 100%);
  background-image: linear-gradient(0deg, #e8e6e6 0%, #fff 100%);
}
.el_dialog_live_lesson .el-dialog__body {
  /*background-color: #ecf5ff;*/
}
.el-dialog__body .exam_begins_rule{
  border-bottom: 1px dotted #ccc;
}
.el-dialog{
  width:80%;
}

.el-pagination{
  position: relative;
}
.main_page{
  min-height: 100vh;
}

@media screen and (max-width: 1024px){
  .el-dialog{
    width: 94%;
    margin-left: 3%;
    margin-right: 3%;
  }
}
/* CSS Common */
.header_black {
  background-color: #323232;
  transition: 0.5s ease;
}

.home {
  /*min-width: 1200px;*/
  margin: 0 auto;
  /* position: relative; */
  font-family: "Microsoft YaHei", sans-serif;
}

.home-div {
  position: relative;
  width: 100%;
  /*min-width: 1200px;*/
  position: fixed;
  z-index: 99;
  transition: 0.5s ease;
  top: 0;
  /* background-color: rgba(0,0,0,0); */
}

.home-div ul {
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  /*margin-left: calc(235 / 1349 * 100%);*/
  /*margin-right: calc(100 / 1349 * 100%);*/
  max-width: 1200px;
  min-width: 580px;
  width: calc(100% - 60px);
  margin: 0 auto;
  position: relative;
}

.home-div ul li {
  height: 60px;
  line-height: 60px;
  color: #fff;
  text-align: center;
  display: inline-block;
  padding: 0 5px;
  min-width: 50px;
}
.home-div ul li.searchPage-home {
  min-width: 200px;
  /*max-width:300px;*/
}

.flag_box img {
  width: 28px;
  display: inline-block;
  margin-bottom: -2px;
}

.home-div ul li .flag_in img {
  width: 28px;
  display: inline-block;
}
.home-div ul li .home-div-label {
  height: 17px;
  line-height: 17px;
  margin-top: 10px;
}

.home-div ul li .home-div-label span:hover,
.home-div ul li label span:hover {
  color: #d0d0d0;
  cursor: pointer;
  transition: 0.5s ease;
}

.home-div ul .logoImg .home-div-label:hover,
.home-div ul .logoImg label:hover {
  border: unset;
}
.home-div ul .logoImg .home-div-label {
  height: 40px;
  margin-top: 0;
}

.home-div ul li span {
  height: 44px;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  color: rgb(250, 250, 250);
  font-size: 12px;
  text-align: center;
  /*transition: 0.5s ease;*/
}
.home-div ul li #flag {
  /* width: 60px; */
  margin-top: 5px;
  border-radius: 5px;
  overflow: hidden;
  text-align: center;
}
.home-div ul li #flag img {
  width: 28px;
  display: inline-block;
}
/*.home-div ul li:last-of-type span {*/
/*  width: 60px;*/
/*}*/
.home-div ul li:last-of-type dl {
  margin-top: -15px;
  padding-bottom: 20px;
}
/*.home-div ul li span img {*/
/*  height: 100%;*/
/*}*/

.home-div ul li:nth-child(1) {
  /*margin-left: 0;*/
  display: inline-flex;
}

.home-div ul li .home-div-span {
  font-family: braggadocio;
  font-size: 21px;
  color: #ff5252 !important;
  margin-left: 20px;
}

.home-div ul li .home-div-span1 {
  font-family: myFont3;
  font-size: 21px;
  color: #fafafa !important;
  margin-right: 20px;
}

.home-div ul li .home_div_item {
  position: absolute;
  margin-left: -15px;
  margin-top: 10px;
}

.home-div ul li .home_div_item dl {
  position: relative;
  overflow: hidden;
  zoom: 1;
  background-color: #323232;
  border-radius: 5px;
}

.home-div ul #logo {
  width: 170px;
  padding-top: 6px;
  box-sizing: border-box;
}

.home-div ul #logo:hover span {
  font-size: 24px !important;
}

.home-div ul li svg g path {
  transition: 0.5s ease;
}

.home-div ul li svg:hover g path {
  fill: #b7b7b7 !important;
  transition: 0.5s ease;
}

.home-div .home_div_item dl dd {
  height: 24px;
  line-height: 24px;
  font-size: 11px;
  /* color: #E8E6E6;
		font-family: museo-slab-w01-100, serif; */
  text-align: left;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  color: rgb(250, 250, 250);
  transition: 0.5s ease;
  padding: 0 10px 0 10px;
}

.home-div .home_div_item dl dd:first-child {
  padding-top: 10px;
}

.home-div .home_div_item dl dd:last-child {
  padding-bottom: 10px;
}

.home-div .home_div_item dl dd:hover {
  color: #d0d0d0 !important;
  transition: 0.5s ease;
}

.home-div ul li label img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-top: 2px;
  /*position: absolute;*/
  padding: 10px 5px 10px 0;
  float: left;
}

.home-div .login_quite {
  width: 18px;
  height: 18px;
  margin-top: 20px;
  /*margin-left: 55px;*/
  background: url(/static/images/quite.png) no-repeat;
  background-size: cover;
  /* transition: 0.5s ease; */
  /*position: absolute;*/
  transition: background 0.5s;
  float: left;
}
.home-div .login_login {
  line-height: 18px;
  width: 73px;
  height: 18px;
  margin-top: 19px;
  /*margin-left: 55px;*/
  background-position: right;
  background: url(/static/images/login.png) no-repeat right;
  background-size: 18px 18px;
  /* transition: 0.5s ease; */
  transition: background 0.5s;
  float: left;
}
.home-div .login_login:hover {
  line-height: 18px;
  width: 73px;
  height: 18px;
  margin-top: 19px;
  /*margin-left: 55px;*/
  background-position: right;
  background: url(/static/images/login_hover.png) no-repeat right;
  background-size: 18px 18px;
  /* transition: 0.5s ease; */
  transition: background 0.5s;
  float: left;
}
.home-div .login_quite:hover {
  background: url(/static/images/quite_hover.png) no-repeat;
  background-size: cover;
  /* transition: 0.5s ease; */
  transition: background 0.5s;
}
/* .home-div ul li label p {
  float: left;
  display: inline-block;
} */
.home-div ul li label .login_p {
  width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /*margin-left: 40px;*/
  text-align: left;
  /*position: absolute;*/
}
.home-div ul li label.login_no {
  position: absolute;
  right: 60px;
}

/*.home-div ul li label p:last-child {*/
/*  margin-left: 68px;*/
/*}*/

.home-div ul li label p span {
  color: #fff !important;
}

.home-div ul li label p span:hover {
  color: #c0c0c0 !important;
}

.home-div1 {
  width: 100%;
  background-color: #323232;
  color: #fff;
  padding-top: 50px;
  padding-bottom: 50px;
  display: inline-table;
}

.home-div1 .home-div1-div {
  width: 1200px;
  margin: 0 auto;
}

.home-div1 ul {
  /* display: flex; */
  display: -webkit-box;
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  zoom: 1;
}

.home-div1 ul li {
  min-width: 319px;
  text-align: center;
}

.home-div1 ul li p span {
  line-height: 40px;
  font-size: 13px;
  color: rgb(250, 250, 250);
  /* font-family: museo-slab-w01-100, serif; */
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  transition: 0.5s ease;
}

.home-div1 ul li p:first-child {
  margin-top: 20px;
}

.home-div1 ul li p span:hover {
  color: #d0d0d0 !important;
  transition: 0.5s ease;
}

.home-div1 ul li:nth-child(2) h1 span {
  width: auto;
  font-family: braggadocio;
  font-size: 25px;
  color: #ff5252;
  line-height: 30px;
  transition: 0.5s ease;
}

.home-div1 ul li:nth-child(2) {
  width: 500px;
  padding-left: 30px;
  padding-right: 30px;
  border-left: 1px solid rgba(153, 153, 151, 1);
  border-right: 1px solid rgba(153, 153, 151, 1);
}

.home-div1 ul li:nth-child(2) h2 span {
  width: auto;
  font-weight: 500;
  font-size: 25px;
  margin-bottom: 30px;
  font-family: myFont3;
  line-height: 30px;
  transition: 0.5s ease;
}
.home-div1 .home-div1-div-div {
  display: inline-flex;
}

.home-div1 .home-div1-div-div dl {
  position: relative;
  zoom: 1;
  overflow: hidden;
}

.home-div1 .home-div1-div-div dl dd {
  width: 60px;
  height: 60px;
  float: left;
}

.home-div1 .home-div1-div-div img {
  width: 40px;
  height: 40px;
  cursor: pointer;
  margin: 0 auto;
  margin-top: 10px;
  transition: 0.2s ease;
}

.home-div1 .home-div1-div-div img:hover {
  width: 46px;
  height: 46px;
  margin-top: 7px;
  transition: 0.2s ease;
}

.dialog_page_header p {
  font-family: braggadocio;
  font-size: 30px;
  color: #ff5252;
  text-align: center;
  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.45);
}

.dialog_page_header p:last-child {
  font-family: myFont3;
  font-size: 30px;
  color: #fafafa;
}

.dialog_page_header_enterprise p:first-child span {
  color: #fafafa;
  font-family: myFont3;
}

.dialog_page_header_enterprise p .font_myFont {
  font-family: myFont !important;
}

.dialog_page_main {
  width: 330px;
  min-height: 350px;
  margin: 0 auto;
  background-color: rgba(50, 50, 50, 1);
  border-radius: 20px;
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.45);
}

.dialog_page_item ul {
  min-width: 260px;
  position: relative;
  font-size: 20px;
  overflow: hidden;
  zoom: 1;
  margin: 0 auto;
  text-align: center;
}

.dialog_page_item ul li {
  width: 100%;
  /* height: 40px; */
  line-height: 40px;
  border-bottom: 1px #414141 solid;
  text-align: center;
}

.dialog_page_item ul li img {
  display: inline-block;
  padding-bottom: 12px;
  height: 15px;
  width: 15px;
  vertical-align: bottom;
}

.dialog_page_item ul li span {
  display: inline-block;
  font-size: 13px;
  color: #999997;
  /* font-family: museo-slab-w01-100, serif; */
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  transition: 0.5s ease;
}

.dialog_page_item ul li span:hover {
  color: #fff;
  transition: 0.5s ease;
}

/*	.dialog_page_item ul li:last-child {
		border-left: 1px #414141 solid;
	}*/

.dialog_page_item_active {
  color: #e8e6e6 !important;
}

.optForm {
  padding-bottom: 30px;
}

.optForm_enterprise {
  padding-top: 30px;
}

.form_btn {
  width: 80px;
  height: 30px;
  margin-top: 30px;
  background-color: unset;
  font-size: 12px;
  color: #fafafa;
  border: 1px #fafafa solid;
  padding: 0 !important;
  margin-left: 109px;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  transition: 0.5s ease;
}

.form_btn:hover {
  background-color: #fff;
  color: #000;
  transition: 0.5s ease;
}

.third_content {
  margin-top: 30px;
}

.third_content p {
  width: 240px;
  margin: 0 auto;
  font-size: 11px;
  color: rgb(232, 230, 230);
  /* font-family: museo-slab-w01-100, serif; */
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.forget {
  height: 10px;
  /* float: right; */
  font-size: 11px;
  color: rgb(232, 230, 230);
  /* font-family: museo-slab-w01-100, serif; */
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  margin-top: 4px;
  margin-right: 4px;
  transition: 0.5s ease;
}
.forget:hover {
  color: #d0d0d0;
  transition: 0.5s ease;
}

.enterprise_login {
  width: auto !important;
  margin-top: 30px !important;
  float: right;
  margin-right: 20px !important;
  font-size: 11px;
  color: rgb(232, 230, 230);
  /* font-family: museo-slab-w01-100, serif; */
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.other_login {
  width: 210px;
  height: 46px;
  display: flex;
  margin: 0 auto;
  margin-top: 20px;
}

.other_login li {
  width: 70px;
  height: 46px;
}

.other_login img {
  width: 40px;
  height: 40px;
  margin: 0 auto;
  margin-top: 3px;
  transition: 0.2s ease;
  cursor: pointer;
}

.other_login img:hover {
  width: 46px;
  height: 46px;
  margin-top: 0;
  transition: 0.2s ease;
}

.login_p .userName {
  display: inline-block;
  width: 80px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
}

.home-div ul li .home_div_item_userName {
  width: 100px;
  position: absolute;
  padding: 10px;
  margin-left: 16px;
  top: 30px;
  margin-top: 0px;
}

.app_download {
  background-color: #323232;
  border-radius: 10px;
  position: absolute;
  margin-left: -18px;
}
.app_download img {
  width: 75px !important;
  height: 75px !important;
  border-radius: 10px !important;
  background-color: #fff;
  padding: 4px;
}

#show_school .home_div_item {
  opacity: 0;
  transition: 0.5s ease-in-out;
}

#show_school .home_div_item dl {
  height: 0;
  /* padding:0; */
  transition: 0.5s ease-in-out;
}

.show_school .home_div_item {
  opacity: 1 !important;
  transition: 0.5s ease-in-out;
}

.show_school .home_div_item dl {
  height: 100% !important;
  /* padding:10px !important; */
  transition: 0.5s ease-in-out;
}

#learn_analysis .home_div_item {
  opacity: 0;
  transition: 0.5s ease-in-out;
}

#learn_analysis .home_div_item dl {
  height: 0;
  /* padding:0; */
  transition: 0.5s ease-in-out;
}

.learn_analysis .home_div_item {
  opacity: 1 !important;
  transition: 0.5s ease-in-out;
}

.learn_analysis .home_div_item dl {
  height: 100% !important;
  /* padding:10px !important; */
  transition: 0.5s ease-in-out;
}

#show_appDownload .app_download {
  opacity: 0;
  transition: 0.5s ease-in-out;
}

.show_appDownload .app_download {
  opacity: 1 !important;
  transition: 0.5s ease-in-out;
}

.home-div1 ul li p.bottom_followUs:hover span {
  color: rgb(250, 250, 250) !important;
}
.logo_top {
  height: 30px;
  margin: 0 auto;
  transform: scale(1);
  -webkit-transform: scale(1);
  transition: 0.5s ease;
  padding-top: 10px;
  padding-right: 15px;
}
.logo_top:hover {
  transform: scale(1.04);
  -webkit-transform: scale(1.04);
  cursor: pointer;
  transition: 0.5s ease;
}
.logo_login {
  height: 80px;
  margin: 0 auto;
  transform: scale(0.7);
  -webkit-transform: scale(0.7);
  transition: 0.5s ease;
}
.logo_login:hover {
  transform: scale(0.8);
  -webkit-transform: scale(0.8);
  cursor: pointer;
  transition: 0.5s ease;
}
.bottom_logo {
  width: 130px;
  height: 66px;
  margin: 16px auto;
}
.logo_bottom {
  width: 130px;
  height: 66px;
  transform: scale(0.85);
  -webkit-transform: scale(0.85);
  transition: 5s ease;
}
.logo_bottom:hover {
  transform: scale(1);
  -webkit-transform: scale(1);
  cursor: pointer;
  transition: 5s ease;
}
.vodeo_box {
  width: 290px;
  height: 200px;
  padding-left: 3px;
}
.login_button {
  margin-top: 20px;
}
.user_input {
  margin-top: 4px;
}
.pass_input {
  margin-top: 12px;
}
.translate {
  color: rgb(232, 230, 230);
  cursor: pointer;
  transition: 0.5s ease-in-out;
}

.translate_type {
  background-color: unset;
  transition: 0.5s ease-in-out;
  margin-top: 10px;
}
.translate span {
  display: inline-block;
  width: 50px;
  text-align: left;
  transition: 0.5s ease-in-out;
}
.translate span:hover {
  color: #d0d0d0;
  transition: 0.5s ease-in-out;
}
.translate_type {
  background-color: #323232;
  border-radius: 5px;
  transition: 0.5s ease-in-out;
}
/*.translate .translate_type dd {*/
/*  height: 20px;*/
/*  line-height: 20px;*/
/*}*/
.translate .translate_type dd {
  height: 30px;
  margin: 0 auto;
  margin-top: 3px;
}
.translate_type dd:hover {
  color: #d0d0d0;
  transition: 0.5s ease-in-out;
}
.home-div ul .login {
  padding-left: 20px;
  display: flex;
  min-width: 150px;
  position: relative;
}

.home-div ul li span span {
  height: 20px;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  color: rgb(250, 250, 250);
  font-size: 12px;
  text-align: center;
  /*transition: 0.5s ease;*/
}
.home-div ul li .icon {
  text-align: center;
}
.home-div #show_school .icon {
  background: url("/static/images/khoahoccuatoi-trang.png");
  height: 26px;
  width: 26px;
  margin: 0 auto;
  margin-bottom: 2px;
  background-size: cover;
}
.home-div #learn_analysis .icon {
  background: url("/static/images/tinhhinhht-trang.png");
  height: 26px;
  width: 26px;
  margin: 0 auto;
  margin-bottom: 2px;
  background-size: cover;
}
.home-div #support .icon {
  background: url("/static/images/support.png");
  height: 40px;
  width: 40px;
  margin: 0 auto;
  /* margin-bottom: 2px; */
  background-size: cover;
}
.home-div #nqt_mes .icon {
  background: url("/static/images/message.png");
  width: 26px;
  height: 26px;
  margin: 0 auto;
  margin-bottom: 2px;
  background-size: cover;
  transform: scale(0.85);
}
.home-div #live_lesson .icon {
  background: url("/static/images/baigiangonline-trang.png");
  height: 26px;
  width: 26px;
  margin: 0 auto;
  margin-bottom: 2px;
  background-size: cover;
}
.home-div #show_school:hover .home-div-label > span,
.home-div #nqt_mes:hover .home-div-label > span,
.home-div #learn_analysis:hover .home-div-label > span,
.home-div #live_lesson:hover .home-div-label > span {
  color: #d0d0d0;
}

#live_lesson .message_span, #nqt_mes .message_span {
  /* width: 18px; */
  height: 18px;
  line-height: 18px;
  background: #ff3f04;
  color: rgb(0, 0, 0);
  font-size: 12px;
  border-radius: 100%;
  margin-top: -30px;
  margin-left: -8px;
  position: absolute;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  border-radius: 10px;
  padding: 0 6px;
}
.login .info_span {
  width: 18px;
  line-height: 18px;
  height: 18px;
  background: #ff3f04;
  color: #fff;
  font-size: 12px;
  border-radius: 100%;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  position: absolute;
  z-index: 100;
  top: 10px;
  right: 45px;
}
.message_content_main {
  padding: 30px;
  font-size: 14px;
  color: #e8e6e6;
  /* font-family:lato-light,lato,sans-serif; */
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}
.exam_btn {
  margin: 0 auto;
  margin-top: 3px;
  display: block;
  text-align: center;
  font-size: 16px;
  color: #fff;
  padding: 6px 17px 6px 17px;
  border: 1px solid #e8e6e6;
  border-radius: 20px;
  background-image: -webkit-linear-gradient(315deg, #02adff 0%, #00d3ff 100%);
  background-image: linear-gradient(135deg, #02adff 0%, #00d3ff 100%);
  font-weight: 200;
  font-style: normal;
  transition: 0.5s ease;
}
.exam_btn:hover {
  color: #333;
}

.exam_btn:hover {
  transition: 0.5s ease;
}
.flag_in {
  height: 20px;
  margin: 0 auto;
  transform: scale(1);
  -webkit-transform: scale(1);
  transition: 0.5s ease;
}
.flag_in:hover {
  transform: scale(1.2);
  -webkit-transform: scale(1.2);
  cursor: pointer;
  transition: 0.5s ease;
}
.in_sp {
  display: none;
}
.in_pc {
  display: unset;
}
.home_footer3 {
  width: 120px;
  margin-right: 10px;
  background: #000;
  text-align: center;
  vertical-align: middle;
  position: relative;
}
.home_footer3 img {
  cursor: pointer;
  width: 30px;
  width: 30px;
  display: inline-block;
  margin-bottom: -2px;
}
.home_footer {
  background: #000;
  padding: 10px 0;
  width: 100%;
  min-width: 580px;
  border-top: 1px solid #333;
}
.home_footer2 {
  max-width: 1200px;
  min-width: 580px;
  width: calc(100% - 60px);
  margin: 0 auto;
  display: flex;
}
.home_footer2 .foot-logo img {
  width: 150px;
}
.home_footer2 .faq_footer {
  color: #ccc;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
}
.home_footer2 .faq_footer a {
  width: 150px;
  color: #ccc;
  font-size: 14px;
}
.home_footer2 .foot-copyright {
  flex: 1;
  color: #ccc;
  line-height: 30px;
  text-align: right;
}
.home_footer2 .foot-copyright a {
  color: #2696ff;
}

.el-table >>> .cell .el-button span a {
  background-image: -webkit-linear-gradient(315deg, #02adff 0%, #00d3ff 100%);
  background-image: linear-gradient(135deg, #02adff 0%, #00d3ff 100%);
  color: #fff;
  padding: 3px 8px;
  border-radius: 15px;
  -webkit-transition: 0.5s ease;
  transition: 0.5s ease;
}
.el-table >>> .cell .el-button span a:hover {
  color: #333;
}

@media screen and (max-width: 950px) {
  .searchPage-home {
    flex: 1;
  }
  .home-div ul li.in_pc {
    display: none;
  }
  .in_sp {
    display: unset;
  }
  .dubble60 {
    width: 100%;
    height: 60px;
    display: table;
  }
  .home-div #show_school .icon,
  .home-div #nqt_mes .icon,
  .home-div #learn_analysis .icon,
  .home-div #live_lesson .icon {
    display: inline-block;
    margin-bottom: -8px;
  }
  .home-div ul li .home-div-label {
    margin-top: 16px;
  }
  .home-div ul li span {
    font-size: 14px;
  }
  #live_lesson .message_span, #nqt_mes .message_span {
    margin-top: -10px;
  }
  #show_school,
  #learn_analysis,
  #live_lesson {
    min-width: 0px;
  }
}
.accecp_protocol {
  color: #cccccc;
  margin: 35px 40px 0 40px;
}
.accecp_protocol input {
  cursor: pointer;
  border: 1px solid #cccccc;
  border-radius: 50%;
}
.accecp_protocol .protocal_link {
  color: #cccccc;
  line-height: 14px;
  cursor: pointer;
}
.accecp_protocol .protocal_link:hover {
  color: #02adff;
}
@media (max-width: 1199px) {
  .home-div ul li {
  height: 70px;
  line-height: 73px;
  color: #fff;
  text-align: center;
  display: inline-block;
  padding: 5px 12px;
  min-width: 50px;
  }
  .home-div #go_home .icon {
    background: url("/static/images/home-trang.png");
    height: 25px;
    width: 28px;
    margin: 0 auto;
    margin-bottom: 2px;
    background-size: cover;
  }
  .home-div #show_school .icon {
    height: 32px;
    width: 32px;
  }
  .home-div #learn_analysis .icon {
    height: 32px;
    width: 32px;
  }
  .home-div #live_lesson .icon {
    height: 32px;
    width: 32px;
  }
  .home-div #nqt_mes .icon {
    height: 32px;
    width: 32px;
  }
  #live_lesson .message_span, #nqt_mes .message_span {margin-left: 10px;}
}
.my_select_live_lesson {
    width: 100%;
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
    border: 1px solid #DCDFE6;
    color: #606266;
    -webkit-appearance: none;
  }
.active_live_lesson{
    height: 50px;
}
.img_exit_login{
  float: right;
  margin-right: 7px;
  margin-top: 6px;
  padding: 5px;
  cursor: pointer;
}
.vn .dialog-custom .dialog_page_item_active {
  margin-left: 15px;
}
.el-message-box__wrapper {
  z-index: 10000000 !important;
}
.btn-nqt---show {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue